import { motion } from 'framer-motion';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { fadeIn, staggerContainer } from '../../utils/motion';
import { useState } from 'react';
import { company, Content, Hire, industries, services } from './HeaderData';
import { Link, useNavigate } from 'react-router-dom';
const MobHeader = ({ mobNavOpen, setmobNavOpen, darkToggle }) => {

    const names = [
        "Services",
        "Industries",
        "Hire developers",
        "Content Hub",
        "Company",

    ];

    const [servicesOpen, setservices] = useState(false)
    const [openIndustries, setopenIndustries] = useState(false)
    const [hire, sethire] = useState(false)
    const [content, setcontent] = useState(false)
    const [companyOpen, setcompany] = useState(false)

    const navigate = useNavigate()

    const handleClick = (item) => {
        if (item === 'Services') {
            setservices(!servicesOpen)
        }
        if (item === 'Industries') {
            setopenIndustries(!openIndustries)
        }
        if (item === 'Hire developers') {
            sethire(!hire)
        }
        if (item === 'Content Hub') {
            setcontent(!content)
        }
        if (item === 'Company') {
            setcompany(!companyOpen)
        }
    };



    return (
        <div className='fixed z-50 left-0 right-0 top-[64px] bottom-[90px]  sm:top-[80px]'>
            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false, amount: 0.25 }}>
                <motion.div
                    variants={fadeIn('up', 'tween', 0, 0.7)}
                >
                    <div className='bg-white max-h-[75vh] overflow-y-auto sm:px-2 py-1 dark:bg-gray-800'>

                        <List
                            sx={{ width: '100%' }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={() => handleClick('Services')} disableRipple>
                                <ListItemText primary={'Services'} sx={{ color: darkToggle ? 'white' : '#757575' }} />
                                {servicesOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
                                {services.map((item, i) => {
                                    let route = item.title.replace(/ /g, "-")
                                    let routeLocation

                                    if (item.title === 'ui/ux design') {

                                        routeLocation = 'ui-ux-design'
                                    }
                                    return <List component={Link}
                                        to={routeLocation ? routeLocation : route}
                                        key={i}
                                        sx={{
                                            '& .MuiTypography-root': {
                                                fontSize: '12px',
                                                color: darkToggle ? 'white' : 'black'
                                            }
                                        }}
                                        disablePadding>
                                        <ListItemButton sx={{ pl: 4 }} disableRipple onClick={() => setmobNavOpen(false)}>
                                            <ListItemIcon>
                                                <img src={item.icon} alt='icon' className='h-[30px] sm:h-7 md:h-8' />
                                            </ListItemIcon>
                                            <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.title} />
                                        </ListItemButton>
                                    </List>
                                })}
                            </Collapse>
                        </List>

                        <List
                            sx={{ width: '100%' }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={() => handleClick('Industries')} disableRipple>
                                <ListItemText primary={'Industries'} sx={{ color: darkToggle ? 'white' : '#757575' }} />
                                {openIndustries ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={openIndustries} timeout="auto" unmountOnExit>
                                {industries.map((item, i) => {
                                    let route = item.title.replace(/ /g, "-")
                                    return <List component={Link}
                                        to={route}
                                        key={i}
                                        sx={{
                                            '& .MuiTypography-root': {
                                                fontSize: '12px',
                                                color: darkToggle ? 'white' : 'black'
                                            }
                                        }}
                                        disablePadding>
                                        <ListItemButton sx={{ pl: 4 }} disableRipple onClick={() => setmobNavOpen(false)}>
                                            <ListItemIcon>
                                                <img src={item.icon} alt='icon' className='h-[30px] sm:h-7 md:h-8' />
                                            </ListItemIcon>
                                            <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.title} />
                                        </ListItemButton>
                                    </List>
                                })}
                            </Collapse>
                        </List>

                        <List
                            sx={{ width: '100%' }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={() => handleClick('Hire developers')} disableRipple>
                                <ListItemText primary={'Hire Developers'} sx={{ color: darkToggle ? 'white' : '#757575' }} />
                                {hire ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={hire} timeout="auto" unmountOnExit>
                                {Hire.map((item, i) => {
                                    let route = item.title.replace(/ /g, "-")
                                    return <List component={Link}
                                        to={route}
                                        key={i}
                                        sx={{
                                            '& .MuiTypography-root': {
                                                fontSize: '12px',
                                                color: darkToggle ? 'white' : 'black'
                                            }
                                        }}
                                        disablePadding>
                                        <ListItemButton sx={{ pl: 4 }} disableRipple onClick={() => setmobNavOpen(false)}>
                                            <ListItemIcon>
                                                <img src={item.icon} alt='icon' className='h-[30px] sm:h-7 md:h-8' />
                                            </ListItemIcon>
                                            <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.title} />
                                        </ListItemButton>
                                    </List>
                                })}
                            </Collapse>
                        </List>

                        <List
                            sx={{ width: '100%' }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={() => handleClick('Content Hub')} disableRipple>
                                <ListItemText primary={'Content Hub'} sx={{ color: darkToggle ? 'white' : '#757575' }} />
                                {content ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={content} timeout="auto" unmountOnExit>
                                {Content.map((item, i) => {
                                    let route
                                    if (item.title === 'e books') {

                                        route = 'ebook-cover-making'

                                    } else {
                                        route = item.title.replace(/ /g, "-")
                                    }
                                    return <List component={Link}
                                        to={route}
                                        key={i}
                                        sx={{
                                            '& .MuiTypography-root': {
                                                fontSize: '12px',
                                                color: darkToggle ? 'white' : 'black'
                                            }
                                        }}
                                        disablePadding>
                                        <ListItemButton sx={{ pl: 4 }} disableRipple onClick={() => setmobNavOpen(false)}>
                                            <ListItemIcon>
                                                <img src={item.icon} alt='icon' className='h-[30px] sm:h-7 md:h-8' />
                                            </ListItemIcon>
                                            <ListItemText sx={{ textTransform: 'capitalize' }} primary={item.title} />
                                        </ListItemButton>
                                    </List>
                                })}
                            </Collapse>
                        </List>

                        <List
                            sx={{ width: '100%' }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={() => handleClick('Company')} disableRipple>
                                <ListItemText primary={'Company'} sx={{ color: darkToggle ? 'white' : '#757575' }} />
                                {companyOpen ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            <Collapse in={companyOpen} timeout="auto" unmountOnExit>
                                {company.map((item, i) => {
                                    let route = item.title.replace(/ /g, "-")
                                    return <List component={Link}
                                        to={route}
                                        key={i}
                                        disablePadding
                                        sx={{
                                            '& .MuiTypography-root': {
                                                fontSize: '12px',
                                                color: darkToggle ? 'white' : 'black'

                                            }
                                        }}
                                    >
                                        <ListItemButton sx={{ pl: 4, fontSize: '8px' }} disableRipple onClick={() => setmobNavOpen(false)}>
                                            <ListItemIcon>
                                                <img src={item.icon} alt='icon' className='h-[30px] sm:h-7 md:h-8' />
                                            </ListItemIcon>
                                            <ListItemText sx={{ textTransform: 'capitalize', fontSize: '10px !important' }} primary={item.title} />
                                        </ListItemButton>
                                    </List>
                                })}
                            </Collapse>
                        </List>
                        <List
                            sx={{ width: '100%' }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                        >
                            <ListItemButton onClick={() => {
                                navigate('/pricing')
                                setmobNavOpen(false)
                            }} disableRipple>
                                <ListItemText primary={'Pricing'} sx={{ color: darkToggle ? 'white' : '#757575' }} />
                            </ListItemButton>

                        </List>

                        <div className='pt-3 py-4 w-[80%] mx-auto'>
                            <button
                                onClick={() => {
                                    navigate('/contact-us')
                                    setmobNavOpen(false)
                                }}
                                className='text-white w-full text-xs px-5 py-2 rounded-2xl bg-red-500 hover:bg-red-600 duration-700 font-semibold md:hidden'>
                                Contact Us
                            </button>
                        </div>

                    </div>
                </motion.div>
            </motion.div>

        </div>
    )
}

export default MobHeader